import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { environment } from 'src/app/environments/environment.js';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';
import { PricingInterval } from './pricing-card.component';

export type SubscriptionPlan = 'free' | 'premium';

type Section = {
	readonly type: 'subscription' | 'checkout';
	readonly pricingInterval: PricingInterval;
};

@Component({
	templateUrl: './subscribe.component.html',
	selector: 'mod-subscribe',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SubscribeComponent extends TypeCoreComponent<UserDb.IUserItem> {
	public readonly refundHref: string = `mailto:${environment.refundEmail}`;
	public readonly refundEmail: string = `${environment.refundEmail}`;

	public readonly paddleContainerClassName: string = 'w-paddle-container';

	public readonly currentSubscription = signal<UserDb.IUserSubscription | undefined>(undefined);
	public readonly subscriptionPlan = signal<SubscriptionPlan>('premium');

	public readonly activeSection = signal<Section>({
		type: 'subscription',
		pricingInterval: 'yearly'
	});

	constructor() {
		super();

		this.sharedDataInit = (data) => {
			this.currentSubscription.set(data.data.subscription);
		};
	}

	handleSubscribe(interval: PricingInterval): void {
		this.activeSection.set({
			type: 'checkout',
			pricingInterval: interval
		});
	}
}
